module.exports = __webpack_public_path__ + "img/tech-top.5982210.png";